import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import payment from '../../img/payment.png';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const PaymentFail = () => {
  const query = useQuery();
  const [orderId, setOrderId] = useState('');

  useEffect(() => {
    setOrderId(query.get('order_id') || '');
  }, [query]);

  return (
    <div className="main-container section-container page-wraper success-msg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-9">
            <div className="form-wrap text-center py-5">
              <div className="img-container">
                <img src={payment} width="120" alt="Payment failed" />
              </div>
              <h3>Payment failed</h3>
              <p>Your payment could not be completed. You can try again from subscription management.</p>
              {orderId && <p className="text-muted">Order ID: {orderId}</p>}
              <Link to="/subscription-management" className="btn btn-primary w-auto me-2">
                Try again
              </Link>
              <Link to="/subscription-management?tab=purchase" className="btn btn-outline-secondary w-auto">
                View plans
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;
